import { Component, inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DensityService } from './services/density.service';
import { LoaderComponent } from './components/loader/loader.component';
import { ThemeService } from './services/theme.service';
import { JwtAuthService } from './services/jwt-auth.service';
import { RouterOutlet } from '@angular/router';
import { BaseToastComponent } from './theme/components/base-toast/base-toast';
import { EnvironmentBannerComponent } from './components/environment-banner/environment-banner';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BaseToastComponent, LoaderComponent, EnvironmentBannerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  @ViewChild('loading', { static: true }) loading: LoaderComponent;

  private readonly densityService = inject(DensityService);

  constructor(
    private themeService: ThemeService,
    private renderer2: Renderer2,
    private jwtService: JwtAuthService
  ) {}

  ngOnInit(): void {
    loading = this.loading;
    this.setTheme();
    // One dataset write on <html>; every grid picks it up from :root.
    this.densityService.restore();
  }

  // setTheme() {
  //   this.themeService.setRenderer(this.renderer2)
  //     .loadStyle(sessionStorage.getItem('theme') || 'dark-theme');
  // }
  setTheme() {
    this.themeService.setRenderer(this.renderer2);
    // Prefer a theme the user previously selected/authored (persisted locally so
    // it survives reloads); otherwise fall back to their server-side default.
    if (!this.themeService.restorePersisted()) {
      const themeTypeId: number = this.jwtService.currentUser.DefaultThemeId;
      this.themeService.loadStyle(themeTypeId);
    }
  }
}
